var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 29,
    fill: "#EBF5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6255 17.75C19.6255 17.0596 20.1851 16.5 20.8755 16.5H37.1255C37.8158 16.5 38.3755 17.0596 38.3755 17.75C38.3755 18.4404 37.8158 19 37.1255 19H32.6811C33.6119 20.0322 34.2622 21.3222 34.512 22.75H37.1255C37.8158 22.75 38.3755 23.3096 38.3755 24C38.3755 24.6904 37.8158 25.25 37.1255 25.25H34.5328C33.963 28.8625 30.8356 31.625 27.063 31.625H25.7233L34.5452 39.3292C35.0551 39.7947 35.091 40.5853 34.6255 41.0951C34.16 41.605 33.3694 41.6409 32.8595 41.1754L22.1022 31.704C21.102 30.7908 21.7481 29.125 23.1025 29.125H27.063C29.45 29.125 31.4511 27.473 31.9854 25.25H20.8755C20.1851 25.25 19.6255 24.6904 19.6255 24C19.6255 23.3096 20.1851 22.75 20.8755 22.75H31.9537C31.3757 20.5907 29.4057 19.0006 27.0642 19L20.8755 19C20.1851 19 19.6255 18.4404 19.6255 17.75Z",
    fill: "#0A57FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVIcon1);
export default __webpack_public_path__ + "static/media/v-icon1.b22a4d1736376f6b5634caaeb26eaadd.svg";
export { ForwardRef as ReactComponent };